import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';

import { MatTableDataSource } from '@angular/material/table';
import { Project } from 'src/app/interfaces/project';
import { ProjectDialogComponent } from '../project-dialog/project-dialog.component';

import { ProjectsapiService } from 'src/app/services/projectsapi.service';
import { AuthenticationService } from '../../../services/authentication.service';

@Component({
  selector: 'app-project-mbed',
  templateUrl: './project-mbeb.component.html',
  styleUrls: ['./project-mbeb.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition(
        'expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')
      ),
    ]),
  ],
})
export class ProjectMbebComponent implements OnInit {
  public displayedColumns = [
    'ID',
    'ShortTitle',
    'SecurityLevel',
    'ArchiveSign',
    'Edit',
  ];
  public dataSource = new MatTableDataSource<Project>();
  public expandedElement: Project | null = null;

  // ✅ НОВЫЕ ПЕРЕМЕННЫЕ для работы с архивом
  public showArchived: boolean = false;
  private allProjects: Project[] = [];

  constructor(
    private projectsApiService: ProjectsapiService,
    private dialog: MatDialog,
    private authServ: AuthenticationService
  ) {}

  ngOnInit() {
    this.getProjectsInformation();
  }

  getProjectsInformation() {
    this.projectsApiService.getProjects(this.authServ.getUser()).subscribe((res) => {
      this.allProjects = res.sort((a, b) => a.ID - b.ID);
      this.filterProjects();
    });
  }

  // ✅ НОВЫЙ МЕТОД: фильтрация проектов
  private filterProjects() {
    if (this.showArchived) {
      this.dataSource.data = [...this.allProjects];
    } else {
      this.dataSource.data = this.allProjects.filter(p => !p.ArchiveSign);
    }
  }

  // ✅ НОВЫЙ МЕТОД: переключение видимости архивных
  toggleArchived(event: any) {
    this.showArchived = event.checked;
    this.filterProjects();
  }

  date() {
    let d = new Date();
    return d.getDate() + '.' + (d.getMonth() + 1) + '.' + d.getFullYear();
  }

  openProjectDialog(project: Project|null) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
 
    dialogConfig.data = {
      project: project,
    };

    const dialogRef = this.dialog.open(
      ProjectDialogComponent,
      dialogConfig
    );

    dialogRef.afterClosed().subscribe((data) => {
      this.getProjectsInformation();
    });
  }

  

  archivate(event: any, project: Project) {
    this.projectsApiService
      .reverse_archive_sign(project, this.authServ.getUser())
      .subscribe((res) => {
        // ✅ Обновляем локальное состояние и применяем фильтр
        project.ArchiveSign = !project.ArchiveSign;
        this.filterProjects();
      });
  }
}